
export const enTranslations = {
    // Header
    'nav.home': 'Home',
    'nav.services': 'Services',
    'nav.products': 'Products',
    'nav.customization': 'Customization',
    'nav.superSupport': 'Super Support',
    'nav.about': 'About',
    'nav.team': 'Team',
    'nav.blog': 'Blog',
    
    // Customization Section
    'customization.title': 'Custom Extensions',
    'customization.subtitle': 'We develop what you\'re missing',
    'customization.intro1': 'Our software already covers the most important processes. But every business has its own requirements – and that\'s exactly what we offer customization for.',
    'customization.intro2': 'We develop individual functions, modules and integrations that are tailored exactly to your needs. Fast, professional and fully integrated into your system.',
    'customization.intro3': 'Whether a small addition or a large new module – we make sure your software fits your business exactly.',
    'customization.whatWeCanDo': 'What we can extend or develop for you',
    'customization.individualFunctions': 'Individual Functions',
    'customization.newModules': 'New modules and workflows',
    'customization.processExtensions': 'Extensions to existing processes',
    'customization.automations': 'Automations according to your requirements',
    'customization.workflows': 'Custom workflows',
    'customization.notifications': 'Notification systems',
    'customization.dataValidation': 'Data validation & checks',
    'customization.interfaces': 'Interfaces & Integrations',
    'customization.apiConnections': 'API connections',
    'customization.paymentIntegrations': 'Payment integrations',
    'customization.accessIntegrations': 'Access or hardware integrations',
    'customization.thirdPartySystems': 'Third-party systems',
    'customization.cloudServices': 'Cloud services connection',
    'customization.dataSync': 'Data synchronization',
    'customization.designUi': 'Design & User Interface',
    'customization.individualLayouts': 'Individual layouts or UI customizations',
    'customization.documentLayouts': 'Custom document and invoice layouts',
    'customization.brandingDesign': 'Branding and corporate design',
    'customization.mobileOptimization': 'Mobile optimization',
    'customization.accessibilityFeatures': 'Accessibility features',
    'customization.darkMode': 'Dark mode & themes',
    'customization.reportsAnalytics': 'Reports & Analytics',
    'customization.individualStats': 'Individual statistics and exports',
    'customization.dashboardCharts': 'Extended dashboard charts',
    'customization.specialReports': 'Special reports and analyses',
    'customization.scheduledReports': 'Automated reports',
    'customization.dataExports': 'Data exports (CSV, PDF, Excel)',
    'customization.kpiTracking': 'KPI tracking & metrics',
    'customization.whyCustomersLove': 'Why customers love our extensions',
    'customization.individual': 'Individual',
    'customization.individualDesc': 'exactly tailored to your processes',
    'customization.seamless': 'Seamlessly integrated',
    'customization.seamlessDesc': 'works like a natural part of the system',
    'customization.fastImplementation': 'Fast implementation',
    'customization.fastImplementationDesc': 'direct coordination & short paths',
    'customization.professional': 'Professionally documented',
    'customization.professionalDesc': 'clean, maintainable code',
    'customization.futureProof': 'Future-proof',
    'customization.futureProofDesc': 'compatible with future updates',
    'customization.howItWorks': 'How an extension works',
    'customization.step1Title': 'Requirements meeting',
    'customization.step1Desc': 'You explain what you need – we advise you technically.',
    'customization.step2Title': 'Quote & effort estimate',
    'customization.step2Desc': 'Transparent and comprehensible.',
    'customization.step3Title': 'Implementation & setup',
    'customization.step3Desc': 'Development, testing, integration and handover.',
    'customization.step4Title': 'Support & further development',
    'customization.step4Desc': 'Maintenance and further adjustments.',
    'customization.ctaTitle': 'We develop what you\'re missing',
    'customization.ctaDesc': 'Whether a small addition or a large new module – we make sure your software fits your business exactly.',
    'customization.ctaButton': 'Contact us for a custom quote',
    
    // Super Support Section
    'superSupport.title': 'Super Support',
    'superSupport.subtitle': 'We\'re here for you – personal, fast and competent',
    'superSupport.intro1': 'Software is only as good as the support behind it. At Initso, you don\'t get anonymous standard support, but real expert help whenever you need it.',
    'superSupport.intro2': 'We don\'t just help you with problems – we think along, find solutions and actively support you in making your business more efficient.',
    'superSupport.whatMakesUsSpecial': 'What makes our support exceptional',
    'superSupport.directContact': 'Direct Contact',
    'superSupport.directContactDesc': 'No call centers, no forwarding – you speak directly with experts who know the system.',
    'superSupport.fastResponse': 'Fast Response Times',
    'superSupport.fastResponseDesc': 'We respond to inquiries usually within a few days or even hours, depending on complexity.',
    'superSupport.proactiveHelp': 'Proactive Help',
    'superSupport.proactiveHelpDesc': 'We reach out when we detect irregularities, support with adjustments and advise on optimizations.',
    'superSupport.clearSolutions': 'Clear, Understandable Solutions',
    'superSupport.clearSolutionsDesc': 'We explain clearly, solve problems reliably and ensure everything runs smoothly.',
    'superSupport.setupTraining': 'Setup & Training Support',
    'superSupport.setupTrainingDesc': 'We help with the start, configure your system and train your team.',
    'superSupport.yourSuccessTitle': 'Your Success is Our Goal',
    'superSupport.yourSuccessDesc1': 'With Initso, you don\'t just get a powerful system, but a strong partner by your side.',
    'superSupport.yourSuccessDesc2': 'We ensure that your business is professionally supported at all times.',
    
    // Hero
    'hero.title': 'Innovative IT Solutions for Modern Businesses',
    'hero.subtitle': 'We help businesses transform and grow with technology.',
    'hero.cta': 'Contact',
    'hero.professional.initso': 'INITSO',
    'hero.professional.line1': 'Your personal IT partner',
    'hero.professional.line2': 'in Switzerland',
    'hero.comprehensive': 'We provide comprehensive IT solutions and services to help businesses grow, optimize operations, and stay secure in the digital world.',
    'hero.services': 'Our Services',
    'hero.contactus': 'Contact Us',
    'hero.tryGymSoftware': 'Try Gym Software',
    // Services
    'services.title': 'Our Services',
    'services.description': 'We offer comprehensive IT solutions to help businesses thrive in the digital landscape. From strategic consulting to technical implementation, our services are designed to meet your needs.',
    'services.consulting.title': 'IT Consulting',
    'services.consulting.description': 'Expert guidance to help you make strategic technology decisions that align with your business goals.',
    'services.consulting.feature1': 'Technology assessment',
    'services.consulting.feature2': 'Digital transformation',
    'services.consulting.feature3': 'IT strategy planning',
    'services.consulting.feature4': 'Process optimization',
    'services.integration.title': 'System Integration',
    'services.integration.description': 'Seamlessly connect your applications and systems to improve efficiency and data flow.',
    'services.integration.feature1': 'API development',
    'services.integration.feature2': 'Legacy system integration',
    'services.integration.feature3': 'Cloud integration solutions',
    'services.integration.feature4': 'System architecture design',
    'services.software.title': 'Custom Software',
    'services.software.description': 'Tailored software solutions designed specifically for your unique business requirements.',
    'services.software.feature1': 'Custom application development',
    'services.software.feature2': 'Mobile app development',
    'services.software.feature3': 'Web applications',
    'services.software.feature4': 'Software maintenance',
    'services.support.title': 'Projectmanagement',
    'services.support.description': 'Comprehensive project management services tailored specifically to the needs of software projects.',
    'services.support.feature1': 'Competent initiation',
    'services.support.feature2': 'Strategic planning',
    'services.support.feature3': 'Efficient execution',
    'services.support.feature4': 'Successful completion',
    // Products
    'products.title': 'Our Products',
    'products.description': 'Discover our suite of innovative products designed to enhance your business operations and digital presence.',
    'products.features': 'Key Features',
    'products.learnMore': 'Learn More',
    'products.prop': 'Propertyprofi',
    'products.prop.description': 'Cloud-based software solutions for modern businesses with integrated tools for project management, customer relations, and data analytics.',
    'products.gym': 'Gym',
    'products.gym.description': 'All-in-one cloud-based gym management software.',
    'products.web': 'Website',
    'products.web.description': 'Your data, your success - Unleash your potential. Creative web design experts, efficient data management and seamless integration of the web shop with payment systems via our API',
    'products.portal': 'Customer Portal',
    'products.portal.description': 'All transactions of your business partners and customer orders in a clear, secure cloud tool',
    // Features
    'feature.individual': 'Customizable',
    'feature.member': 'Member administration',
    'feature.bill': 'Invoicing',
    'feature.integration': 'Integrations',
    'feature.report': 'Reports',
		'feature.access': 'Access control',
		
		// Marquee Features
		'feature.memberManagement': 'Member Management',
		'feature.invoicing': 'Invoicing',
		'feature.billing595': 'Billing according to 595',
		'feature.accessControl': 'Access Control',
		'feature.reportGeneration': 'Report Generation',
		'feature.analytics': 'Analytics',
		'feature.onlineRegistration': 'Online Registration',
		'feature.customerCommunication': 'Customer Communication',
		'feature.changeHistory': 'Change History',
		'feature.subscriptionManagement': 'Subscription Management',
		'feature.subscriptionPause': 'Subscription Pause',
		'feature.installmentPayments': 'Installment Payments',

		'feature.crm': 'CRM',
		'feature.management': 'Property management',
		'feature.accounting': 'Accounting',
		'feature.document': 'Document archive',
		'feature.insurance': 'insurance management',

		'feature.creativ': 'Creative web design',
    'feature.custom': 'Customized website solutions',
    'feature.data': 'Efficient data management',
    'feature.api': 'API connections',
    'feature.responsive': 'Responsive web design',

    'feature.application': 'Efficient application processing',
    'feature.visualization': 'Data visualization',
    'feature.customer': 'Competent customer service',
    'feature.productivity': 'Increase productivity',
    'feature.scalable': 'Scalable cloud architecture',
    'feature.realtime': 'Real-time collaboration tools',
    'feature.backup': 'Automated data backup',
    'feature.security': 'Advanced security protocols',
    'feature.predictive': 'Predictive analytics',
    'feature.reporting': 'Automated reporting',
    'feature.kpi': 'Custom KPI tracking',
    'feature.dataIntegration': 'Multi-source data integration',
    'feature.monitoring': 'Real-time threat monitoring',
    'feature.intrusion': 'Intrusion detection systems',
    'feature.encryption': 'Data encryption protocols',
    'feature.compliance': 'Security compliance audits',
    'feature.updates': 'Automated security updates',
    'feature.pipelines': 'Automated CI/CD pipelines',
    'feature.code': 'Code quality metrics',
    'feature.collaborative': 'Collaborative development environment',
    'feature.version': 'Version control integration',
    'feature.container': 'Containerized development workflows',
    // About
    'about.title': 'About Us',
    'about.description': 'We are a team of dedicated professionals committed to delivering exceptional IT solutions.',
    'about.aboutinitso': 'About INITSO',
    'about.leadingprovider': 'INITSO  is a customer-centric IT service provider based in Switzerland, dedicated to delivering high-quality technology solutions for businesses of all sizes.',
    'about.experience': 'With years of experience and a team of qualified professionals, we offer comprehensive IT services from consulting and development to maintenance and support. Our focus is on creating customized solutions that address specific business needs and drive growth.',
    'about.mission': 'Our Mission',
    'about.mission.description': 'To empower businesses through innovative technology solutions.',
    'about.vision': 'Our Vision',
    'about.vision.description': 'To be the trusted technology partner for businesses across Switzerland.',
    'about.quality': 'Quality',
    'about.quality.description': 'We rely on the highest quality standards in all our projects and solutions to achieve sustainable results for our customers. Every detail is carefully reviewed and optimized so that our solutions are not only functional, but also reliable and future-proof.',
    'about.innovation': 'Innovation',
    'about.innovation.description': 'Modern technologies and creative approaches enable us to develop innovative solutions for our customers\' challenges. We always stay on the pulse of the times and integrate the latest developments into our work to create customized solutions.',
		// Testimonials
			'testimonials.title': 'Testimonials',
    // Contact
    'contact.title': 'Contact Us',
    'contact.description': 'Ready to transform your business with technology? Get in touch with our team.',
    'contact.form.name': 'Your Name',
    'contact.form.email': 'Your Email',
    'contact.form.message': 'Your Message',
    'contact.messagePlaceholder': 'Please contact me.',
    'contact.form.submit': 'Send Message',
    'contact.sending': 'Sending...',
    'contact.info.address': 'Address',
    'contact.info.email': 'Email',
    'contact.info.phone': 'Phone',
		'contact.messageSent':'Message Sent',
		'contact.thankYou':"Thank you for contacting us. We'll get back to you soon!",
		'contact.error':'Error',
		'contact.errorMessage':'There was a problem sending your message. Please try again.',
		'contact.contactInfo': 'Contact Information',
		'contact.businessHours': 'Opening Hours',
		'contact.businessHoursValue': '9:00 AM - 6:00 PM',
		'contact.weekdays': 'Weekdays',
		'contact.weekend': 'Weekends',
		'contact.closed': 'closed',
    // Footer
    'footer.newsletter': 'Subscribe to our newsletter for updates and insights.',
    'footer.subscribe': 'Subscribe',
    'footer.rights': 'All rights reserved.',
    'footer.services': 'Services',
    'footer.itconsulting': 'IT Consulting',
    'footer.systemintegration': 'System Integration',
    'footer.customsoftware': 'Custom Software',
    'footer.itsupport': 'IT Support',
    'footer.cloudservices': 'Cloud Services',
    'footer.company': 'Company',
    'footer.aboutus': 'About Us',
    'footer.careers': 'Careers',
    'footer.blog': 'Blog',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms of Service',
    'footer.youremail': 'Your email',
		'footer.error': "Error",
		'footer.validEmail': 'Please enter a valid email address',
		'footer.subscribed': "Subscribed!",
    'footer.thankYou':"Thank you for subscribing to our newsletter.",
		'footer.errorMessage':"There was a problem with your subscription. Please try again.",
    // Product Detail Pages - Gym
    'gym.title': 'Gym Management',
    'gym.subtitle': 'All-in-one Gym Management Software. The future of fitness studio management - modern, efficient and user-friendly.',
    'gym.heroIntro': 'All-in-one Gym Management Software',
    'gym.cloudBased': '100% cloud-based',
    'gym.readyOn': 'ready to use on',
    'gym.backToOverview': 'Back to Overview',
    'gym.navFeatures': 'Main Features',
    'gym.navShowcase': 'Insight',
    'gym.navPricing': 'Pricing',
    'gym.navAllFeatures': 'All Features',
    'gym.navWhyUs': 'Why Us',
    'gym.mainFeatures': 'Main Features',
    'gym.featuresDescription': 'Our Gym Management Software offers all the functions you need to successfully run your fitness studio, including billing according to 595.',
    'gym.customizable': 'Customizable',
    'gym.customizableDesc': 'Adapt the software completely to your needs. Flexible configuration for any type of fitness studio.',
    'gym.memberManagement': 'Member Management',
    'gym.memberManagementDesc': 'Complete management of your members with profiles, contracts, training history and personal data.',
    'gym.invoicing': 'Invoicing',
    'gym.invoicingDesc': 'Automatic invoice creation and payment processing with various payment methods and reminders.',
    'gym.billing595': 'Billing according to 595',
    'gym.billing595Desc': 'We support billing according to 595 directly in your Gym Management Software - clear, centralized and aligned with your invoicing workflows.',
    'gym.billing595ImageAlt': 'Invoice view for billing according to 595 in the Gym Management Software',
    'gym.onlineRegistrationImageAlt': 'Online registration in the Gym Management Software',
    'gym.memberManagementImageAlt': 'Member management in the Gym Management Software',
    'gym.invoicingImageAlt': 'Invoicing in the Gym Management Software',
    'gym.billing595FeatureImageAlt': 'Billing according to 595 in the Gym Management Software',
    'gym.integrationsImageAlt': 'Integrations in the Gym Management Software',
    'gym.reportsImageAlt': 'Reports and analytics in the Gym Management Software',
    'gym.accessControlImageAlt': '24/7 access control in the Gym Management Software',
    'gym.customizableImageAlt': 'Customizable Gym Management Software',
    'gym.subscriptionManagementImageAlt': 'Subscription management in the Gym Management Software',
    'gym.customerCommunicationImageAlt': 'Customer communication in the Gym Management Software',
    'gym.integrations': 'Integrations',
    'gym.integrationsDesc': 'Seamless integration with existing systems and equipment for a unified experience.',
    'gym.reports': 'Reports',
    'gym.reportsDesc': 'Comprehensive reports and analyses on membership numbers, revenue, utilization and many other KPIs.',
    'gym.accessControl': '24/7 Access Control',
    'gym.accessControlDesc': 'Modern access control with digital membership cards and automatic attendance tracking.',
    'gym.onlineRegistration': 'Online Registration',
    'gym.onlineRegistrationDesc': 'Enable your members to register online conveniently 24/7 - fast, simple and secure.',
    'gym.subscriptionManagement': 'Subscription Management',
    'gym.subscriptionManagementDesc': 'Manage all subscriptions centrally - from contract changes to automatic renewals and cancellations.',
    'gym.customerCommunication': 'Customer Communication',
    'gym.customerCommunicationDesc': 'Stay in touch with your members through integrated communication tools for newsletters, notifications and personal messages.',
    'gym.showcaseTitle': 'Gym Management Insight',
    'gym.showcase1Title': 'Member Management',
    'gym.showcase1Desc': 'With our intuitive customer overview, you always keep all important information about your customers in view. Through fast and precise search functions, you can find what you need in no time.',
    'gym.showcase2Title': 'Online Registration',
    'gym.showcase2Desc': 'Register new members and prospects flexibly online or directly on-site. Whether via laptop, tablet or smartphone - registration is child\'s play and possible from anywhere.',
    'gym.showcase3Title': 'Reporting & Analytics',
    'gym.showcase3Desc': 'Detailed reports and analyses for better business decisions and success optimization. Simplify your payment processing and gain valuable time back.',
    'gym.showcase4Title': 'Billing according to 595',
    'gym.showcase4Desc': 'INITSO offers billing according to 595 as a visible part of your digital studio management, keeping invoices, open balances and payment status in one central view.',
    'gym.whyOurSoftware': 'Why our Gym Software?',
    'gym.timeSaving': 'Time Saving',
    'gym.timeSavingDesc': 'Automate recurring tasks and focus on what matters - your members.',
    'gym.increasedEfficiency': 'Increased Efficiency',
    'gym.increasedEfficiencyDesc': 'Optimize your operational processes and significantly reduce administrative effort.',
    'gym.betterMemberExperience': 'Better Member Experience',
    'gym.betterMemberExperienceDesc': 'Offer your members modern digital services and improve customer satisfaction.',
    'gym.dataBasedDecisions': 'Data-Based Decisions',
    'gym.dataBasedDecisionsDesc': 'Make informed business decisions based on meaningful data and analyses.',
    'gym.readyForFuture': 'Ready for the Future of Gym Management?',
    'gym.readyForFutureDesc': 'Let our experts show you how our Gym Management Software can revolutionize your fitness studio.',
    'gym.requestDemo': 'Request Demo',
    'gym.pricing': 'Pricing',
    'gym.pricingDesc': 'Fair prices for every studio size - Start today',
    'gym.pricingTier1': 'Basic',
    'gym.pricingTier1Members': 'Up to 100 members',
    'gym.pricingTier2': 'Advanced',
    'gym.pricingTier2Members': '100 - 500 members',
    'gym.pricingTier3': 'Pro',
    'gym.pricingTier3Members': '500 - 1000 members',
    'gym.pricingTier4': 'Business',
    'gym.pricingTier4Members': 'Over 1000 members',
    'gym.pricingByAgreement': 'By Agreement',
    'gym.pricingPerMonth': 'CHF per month',
    'gym.pricingPrice2': '250 CHF / month',
    'gym.pricingPrice3': '350 CHF / month',
    'gym.pricingPrice4': '500 CHF / month',
    'gym.pricingTerms': 'Auto-renewal.',
    'gym.pricingCancelAnytime': 'Cancel anytime.',
    'gym.pricingPlatforms': 'Available for',
    'gym.pricingAllFeatures': 'ALL FEATURES',
    'gym.pricingContactButton': 'Contact Us',
    'gym.allFeaturesTitle': 'All Features',
    'gym.allFeatures1Title': 'Online Registration',
    'gym.allFeatures1Item1': 'Web registration via your website',
    'gym.allFeatures1Item2': 'Single, couple, and family registration',
    'gym.allFeatures2Title': 'Settings & System Configuration',
    'gym.allFeatures2Item1': 'Customizable design',
    'gym.allFeatures2Item2': 'SMTP configuration',
    'gym.allFeatures2Item3': 'Bank account settings',
    'gym.allFeatures2Item4': 'Staff management',
    'gym.allFeatures2Item5': 'Subscription configuration',
    'gym.allFeatures2Item6': 'Billing positions',
    'gym.allFeatures2Item7': 'Document templates',
    'gym.allFeatures2Item8': 'Text and email templates',
    'gym.allFeatures3Title': 'Dashboard, Analytics & Exports',
    'gym.allFeatures3Item1': 'Excel exports',
    'gym.allFeatures3Item2': 'Revenue, payment, and customer charts',
    'gym.allFeatures3Item3': 'Outstanding payments overview',
    'gym.allFeatures4Title': 'Member Management',
    'gym.allFeatures4Item1': 'Member list with filter options',
    'gym.allFeatures4Item2': 'Manual member creation',
    'gym.allFeatures4Item3': 'Detail view with subscriptions, invoices, payments, and documents',
    'gym.allFeatures4Item4': 'Change history',
    'gym.allFeatures5Title': 'Subscription / Contract Management',
    'gym.allFeatures5Item1': 'Automatic and manual contract creation with email',
    'gym.allFeatures5Item2': 'Automatic and manual invoicing',
    'gym.allFeatures5Item3': 'Status changes',
    'gym.allFeatures5Item4': 'Pause options with automatic renewal',
    'gym.allFeatures6Title': 'Accounting',
    'gym.allFeatures6Item1': 'Customer and global invoice tables',
    'gym.allFeatures6Item2': 'Manual/automatic billing with sending',
    'gym.allFeatures6Item3': 'Custom invoices',
    'gym.allFeatures6Item4': 'Installment payment support',
    'gym.allFeatures6Item5': 'Up to 3 reminder levels',
    'gym.allFeatures6Item6': 'Manual payment entry',
    'gym.allFeatures6Item7': 'Modifiable/reissuable invoices',
    'gym.allFeatures6Item8': 'QR invoices for Swiss banks',
    'gym.allFeatures6Item9': 'Billing according to 595',
    'gym.allFeatures7Title': 'Document Management',
    'gym.allFeatures7Item1': 'Automatic document creation',
    'gym.allFeatures7Item2': 'Custom uploads',
    'gym.allFeatures7Item3': 'Template generation',
    'gym.allFeatures7Item4': 'PDF/JPG/PNG preview',
    'gym.allFeatures8Title': 'Automatic Bank Reconciliation',
    'gym.allFeatures8Item1': 'CAMT file upload',
    'gym.allFeatures8Item2': 'Automatic payment assignment by reference number',
    'gym.allFeatures8Item3': 'Eliminates manual work',
    'gym.allFeatures9Title': '24/7 Access Control',
    'gym.allFeatures9Item1': 'Digital member cards',
    'gym.allFeatures9Item2': 'Automatic attendance tracking',
    'gym.allFeatures9Item3': 'Integration with access systems like turnstiles, doors, RFID, NFC',
    'gym.allFeatures9Item4': 'Ideal for 24-hour gym operations',
    'gym.tarif595FaqTitle': 'Tarif 595 FAQ',
    'gym.tarif595FaqSubtitle': 'Key answers about the new invoicing standard for Swiss fitness studios.',
    'gym.tarif595FeaturedQuestion': 'Do I need external tools for Tarif 595 documents?',
    'gym.tarif595FeaturedAnswer': 'No. The documents are created directly in the Initso Gym Software - without media breaks.',
    'gym.tarif595Faq1Question': 'What changes for you?',
    'gym.tarif595Faq1Answer': 'From 1 January 2027, health-promoting fitness services will be checked by insurers using Tarif 595 and a standardized reimbursement document. Instead of the previous confirmations, members will need a structured document that correctly contains the required information according to the Tarif 595 scheme.',
    'gym.tarif595Faq2Question': 'What is Tarif 595?',
    'gym.tarif595Faq2Answer': 'Tarif 595 is a Swiss tariff for outpatient health-promoting services in supplementary insurance. From 2027, it becomes relevant for fitness studios and similar providers so that services can be submitted to health insurers in a clear and consistent structure.',
    'gym.tarif595Faq5Question': 'How can I use the tariff in the INITSO Gym System?',
    'gym.tarif595Faq5Answer': 'INITSO integrates this feature into the Gym Software and automatically creates a Tarif 595 document that can be sent to the customer directly from the INITSO system.',
    'gym.tarif595Faq6Question': 'When will the Tarif 595 feature be available?',
    'gym.tarif595Faq6Answer': 'Creation of reimbursement documents according to Tarif 595 will be automatically enabled in the system from 01.01.2027, so studios can use the new standard as soon as it becomes mandatory.',
    'gym.tarif595Faq7Question': 'What happens to the previous subscription and attendance confirmations?',
    'gym.tarif595Faq7Answer': 'Previous attendance confirmations will no longer be sufficient for billing with health insurers from 2027. The reimbursement document according to Tarif 595 must be used instead.',
    'gym.tarif595Faq8Question': 'How can I learn more about INITSO Gym and Tarif 595?',
    'gym.tarif595Faq8Answer': 'Fill out the contact form below to receive a free consultation.',
    // Product Detail Pages - PropertyProfi
    'property.title': 'PropertyProfi',
    'property.subtitle': 'Property management made easy. With our cloud-based tool, you have all information structured available and all your tasks under control.',
    'property.mainFeatures': 'Main Features',
    'property.featuresDescription': 'PropertyProfi offers you all the tools you need for efficient property management.',
    'property.crmSystem': 'CRM System',
    'property.crmSystemDesc': 'Manage all your customers, tenants and business partners centrally in one place with comprehensive contact information and communication history.',
    'property.propertyManagement': 'Property Management',
    'property.propertyManagementDesc': 'Organize all your properties structured with detailed information on objects, units and rental relationships.',
    'property.accounting': 'Accounting',
    'property.accountingDesc': 'Integrated accounting functions for seamless management of all financial aspects of your properties.',
    'property.documentArchive': 'Document Archive',
    'property.documentArchiveDesc': 'Secure storage of all important documents with intelligent categorization and fast search function.',
    'property.insuranceManagement': 'Insurance Management',
    'property.insuranceManagementDesc': 'Clear management of all insurances with automatic reminders for renewals and payments.',
    'property.reportingAnalytics': 'Reporting & Analytics',
    'property.reportingAnalyticsDesc': 'Comprehensive reports and analyses on profitability and performance of your real estate portfolios.',
    'property.showcaseTitle': 'PropertyProfi in Action',
    'property.showcase1Title': 'Dashboard Overview',
    'property.showcase1Desc': 'Central overview of all your properties with important key figures and current activities at a glance.',
    'property.showcase2Title': 'Financial Management',
    'property.showcase2Desc': 'Comprehensive accounting functions for managing all financial aspects of your real estate portfolios.',
    'property.showcase3Title': 'Document Management',
    'property.showcase3Desc': 'Secure and organized storage of all important documents with intelligent search function.',
    'property.whyPropertyProfi': 'Why PropertyProfi?',
    'property.cloudBased': 'Cloud-based',
    'property.cloudBasedDesc': 'Access your data from anywhere and anytime - secure and reliable.',
    'property.userFriendly': 'User-friendly',
    'property.userFriendlyDesc': 'Intuitive operation without long training time - immediately ready for use.',
    'property.scalable': 'Scalable',
    'property.scalableDesc': 'Grows with your company - from individual objects to large portfolios.',
    'property.swissQuality': 'Swiss Quality',
    'property.swissQualityDesc': 'Developed in Switzerland according to the highest data protection and security standards.',
    'property.readyForPropertyProfi': 'Ready for PropertyProfi?',
    'property.readyForPropertyProfiDesc': 'Contact us for a personal demonstration and learn how PropertyProfi can revolutionize your property management.',
    'property.contactNow': 'Contact Now',
    // Product Detail Pages - Web
    'web.title': 'Websites & Webshops',
    'web.subtitle': 'Your data, your success – Unleash your potential. Creative web design experts, efficient data management and seamless integration.',
    'web.ourWebServices': 'Our Web Services',
    'web.webServicesDesc': 'From creative design to technical implementation - we offer you everything for your successful web presence.',
    'web.creativeWebDesign': 'Creative Web Design',
    'web.creativeWebDesignDesc': 'Individual and appealing designs that perfectly reflect your brand and inspire your target audience.',
    'web.customSolutions': 'Custom Solutions',
    'web.customSolutionsDesc': 'Every website is developed specifically for your requirements - no templates, but real individuality.',
    'web.efficientDataManagement': 'Efficient Data Management',
    'web.efficientDataManagementDesc': 'Intelligent data structures and content management systems for easy management of your content.',
    'web.apiConnections': 'API Connections',
    'web.apiConnectionsDesc': 'Seamless integration of third-party systems and payment systems for extended functionality of your website.',
    'web.responsiveDesign': 'Responsive Design',
    'web.responsiveDesignDesc': 'Perfect display on all devices - from desktop to smartphone for optimal user experience.',
    'web.ecommerceIntegration': 'E-Commerce Integration',
    'web.ecommerceIntegrationDesc': 'Complete webshop solutions with secure payment systems and inventory management for your online success.',
    'web.showcaseTitle': 'Our Web Projects',
    'web.showcase1Title': 'Responsive Web Design',
    'web.showcase1Desc': 'Modern, responsive websites that work perfectly on all devices - from desktop to smartphone.',
    'web.showcase2Title': 'E-Commerce Solutions',
    'web.showcase2Desc': 'Professional webshop development with secure payment systems and comprehensive product management.',
    'web.showcase3Title': 'Data Visualization',
    'web.showcase3Desc': 'Interactive dashboards and reports for a clear presentation of your business data.',
    'web.ourDevelopmentProcess': 'Our Development Process',
    'web.needsAnalysis': 'Needs Analysis',
    'web.needsAnalysisDesc': 'We analyze your requirements and develop the optimal concept together with you.',
    'web.designPrototyping': 'Design & Prototyping',
    'web.designPrototypingDesc': 'Creation of mockups and prototypes for a clear idea of the end result.',
    'web.development': 'Development',
    'web.developmentDesc': 'Professional implementation with the latest technologies and highest quality standards.',
    'web.launchSupport': 'Launch & Support',
    'web.launchSupportDesc': 'Successful go-live with subsequent support and continuous support.',
    'web.readyForNewWebPresence': 'Ready for Your New Web Presence?',
    'web.readyForNewWebPresenceDesc': 'Let us realize your vision together. Contact us for a non-binding consultation.',
    'web.discussProject': 'Discuss Project',
    // Product Detail Pages - Portal
    'portal.title': 'Customer Portal',
    'portal.subtitle': 'All transactions of your business partners and customer orders in a clear, secure cloud tool.',
    'portal.portalFeatures': 'Portal Features',
    'portal.portalFeaturesDesc': 'Our customer portal offers a central platform for all your business processes and customer interactions.',
    'portal.efficientApplicationProcessing': 'Efficient Application Processing',
    'portal.efficientApplicationProcessingDesc': 'Streamline your application processing with automated workflows and digital document management.',
    'portal.dataVisualization': 'Data Visualization',
    'portal.dataVisualizationDesc': 'Intelligent dashboards and reports for better business decisions based on real-time data.',
    'portal.competentCustomerService': 'Competent Customer Service',
    'portal.competentCustomerServiceDesc': 'Integrated communication tools and ticket system for first-class customer service and support.',
    'portal.increaseProductivity': 'Increase Productivity',
    'portal.increaseProductivityDesc': 'Automation of recurring tasks and optimized workflows for maximum efficiency.',
    'portal.secureDataProcessing': 'Secure Data Processing',
    'portal.secureDataProcessingDesc': 'Highest security standards and data protection compliance for trustworthy business relationships.',
    'portal.userFriendlyInterface': 'User-friendly Interface',
    'portal.userFriendlyInterfaceDesc': 'Intuitive operation and customizable dashboards for an optimal user experience.',
    'portal.showcaseTitle': 'Portal Features in Detail',
    'portal.showcase1Title': 'User Dashboard',
    'portal.showcase1Desc': 'Intuitive user interface with customizable dashboards for optimal user experience.',
    'portal.showcase2Title': 'Workflow Management',
    'portal.showcase2Desc': 'Automated processes and efficient workflow management for maximum productivity.',
    'portal.showcase3Title': 'Secure Data Processing',
    'portal.showcase3Desc': 'Highest security standards and GDPR-compliant data processing for trustworthy cooperation.',
    'portal.advantagesOfOurPortal': 'Advantages of our Portal',
    'portal.centralizedManagement': 'Centralized Management',
    'portal.centralizedManagementDesc': 'All your business processes in one place - clearly and efficiently managed.',
    'portal.realtimeSynchronization': 'Real-time Synchronization',
    'portal.realtimeSynchronizationDesc': 'All data is synchronized in real-time for consistent and current information.',
    'portal.scalableArchitecture': 'Scalable Architecture',
    'portal.scalableArchitectureDesc': 'The portal grows with your company and adapts to your requirements.',
    'portal.customizableWorkflows': 'Customizable Workflows',
    'portal.customizableWorkflowsDesc': 'Configure processes according to your specific business requirements.',
    'portal.readyForYourOwnPortal': 'Ready for Your Own Portal?',
    'portal.readyForYourOwnPortalDesc': 'Discover how our customer portal can revolutionize your business processes and increase your productivity.',
    'portal.requestPortalDemo': 'Request Portal Demo',
    // Contact Form
    'contactForm.title': 'Get in Touch',
    'contactForm.description': 'Do you have questions about {productName}? Contact us for more information or personal consultation.',
    'contactForm.yourInquiry': 'Your Inquiry about {productName}',
    'contactForm.name': 'Name *',
    'contactForm.email': 'Email *',
    'contactForm.message': 'Message *',
    'contactForm.messagePlaceholder': 'I am interested in {productName} and would like more information...',
    'contactForm.sendMessage': 'Send Message',
    'contactForm.sending': 'Sending...',
    'contactForm.messageSent': 'Message Sent',
    'contactForm.thankYou': 'Thank you for your inquiry. We will get back to you soon!',
    'contactForm.error': 'Error',
    'contactForm.errorMessage': 'An error occurred while sending your message. Please try again.',
  // Blog
  'blog.title': 'Blog',
  'blog.subtitle': 'Insights, practical knowledge and news about software, digital transformation and INITSO.',
  'blog.loading': 'Loading posts',
  'blog.loadError': 'The posts could not be loaded. Please try again later.',
  'blog.unavailable': 'Blog unavailable',
  'blog.empty': 'No posts have been published yet',
  'blog.readMore': 'Read post',
  'blog.pagination': 'Blog pages',
  'blog.previous': 'Previous page',
  'blog.next': 'Next page',
  'blog.backToOverview': 'Back to the blog',
  'blog.notFoundTitle': 'Post not found',
  'blog.notFoundDescription': 'The requested post does not exist or has been removed.',
  // Buttons
  'buttons.login': 'Login',
  'buttons.startTrial': 'Start trial',
  // Team Roles
  'CEO': 'CEO',
  'CFO': 'CFO',
  'Chief Software Developer': 'Chief Software Developer',
  'Chief Software Architect': 'Chief Software Architect',
  'Head Frontend Entwickler': 'Head Frontend Developer',
  'Q&I Developer': 'Q&I Developer',
  'Sales & Marketing': 'Sales & Marketing'
  } as const;
